module.exports = __webpack_public_path__ + "img/question-empty.574229ed.svg";